export function showSnackbar(payload) {
  return dispatch => {
    return dispatch({ type: 'snackbar/show', payload })
  }
}

export function resetSnackbar() {
  return dispatch => {
    return dispatch({ type: 'snackbar/reset' })
  }
}
